import {Box, Pagination as MaterialPagination} from '@mui/material';

const Pagination = (props) => {
    const {setPage, ...rest} = props;
    if(rest.count < 2){
        return <></>
    }
    return <MaterialPagination 
        {...rest}
        sx={{'&> ul': {justifyContent: 'center', py: 2}}}
        shape="rounded"
        onChange={(e, v) => setPage(v)} />
        
}

export default Pagination;